export enum SessionInvalidReason {
	Expired = "expired",
	Deactivated = "deactivated",
}

/** The stored Cognito session can not be refreshed anymore, the user has to log in again. */
export class SessionInvalidError extends Error {
	public override readonly name = "SessionInvalidError";

	constructor(
		public readonly reason: SessionInvalidReason,
		options?: ErrorOptions,
	) {
		super(`Cognito session is no longer valid (${reason})`, options);
	}
}
